export default "__VITE_ASSET__DjszTlVF__"